import React from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import { LoginCallback, SecureRoute, Security } from "@okta/okta-react";
import { QueryClientProvider } from "@tanstack/react-query";

import ErrorPage from "@/v1/components/pages/ErrorPage";
import Routes from "@/v1/components/pages/router";
import routes from "@/v1/config/routes";

import { useToastProxy } from "./v1/hooks/useToastProxy";
import { queryClient } from "./v1/utils/queryClient";
import AleaLayout from "./v2/components/organisms/AleaLayout";
import GameLabV3Mobile from "./v2/components/pages/Tools/GameLabV3Mobile";
import ApmRouteTracker from "./v2/components/watchers/ApmRouteTracker/ApmRouteTracker";
import { LoginProtectedRoutes } from "./v2/routes/LoginProtectedRoutes/LoginProtectedRoutes";
import { useUserStore } from "./v2/store/useUserStore";
import { authentication, CALLBACK_PATH } from "./v2/utils/authentication";
import { canAccessRoute } from "./v2/utils/canAccessRoute";

import "./v1/styles/global.scss";

const App = () => {
  useToastProxy();
  const userPermissions = useUserStore((state) => state.activePermissions);
  const isOwner = useUserStore((state) => state.isOwner);

  return (
    <Router>
      <ApmRouteTracker />
      <Security authService={authentication}>
        <Switch>
          <Route path={CALLBACK_PATH} component={LoginCallback} />
          <LoginProtectedRoutes>
            <QueryClientProvider client={queryClient}>
              <Switch>
                <Route
                  exact
                  path={routes
                    .filter((route) =>
                      canAccessRoute(route, { permissions: userPermissions, isOwner }),
                    )
                    .map((route) => route.path)}
                >
                  <AleaLayout>
                    <Routes />
                  </AleaLayout>
                </Route>
                <Route
                  path="/games/:gameID/*"
                  component={({ match }) => {
                    return <Redirect to={`/games/${match.params.gameID}`} />;
                  }}
                />
                <SecureRoute path="/mobile-game-lab" component={GameLabV3Mobile} />
                <SecureRoute path="/error" component={ErrorPage} />
                <SecureRoute component={ErrorPage} />
              </Switch>
            </QueryClientProvider>
          </LoginProtectedRoutes>
        </Switch>
      </Security>
    </Router>
  );
};

export default App;
